query MarketingLimits {
  marketingLimits {
    contactListsPerAudience
    broadcastNameLength
    audienceConditions
    audienceValues
    audienceMaxDays
    audienceMaxNumber
    emailUrlVariables
  }
}
